import React, { Fragment } from 'react';
import { Avatar, Button, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import { urlVoucher } from '../../services/urls';
import { isMobile } from 'react-device-detect';
import { sendMobile } from '../../functions/mobile';
import { CloudDownload } from '@material-ui/icons';
const ShowPayrollVouchers = props => {
    const {dataTransactions} = props
    const handleDownloadVoucherPayroll = (nameFile) => {
        if (localStorage.cb_app !== undefined) {
            sendMobile(JSON.stringify({
                type: 'openLink',
                data: urlVoucher+nameFile+".pdf"
              }))
        } else {
            window.open(urlVoucher+nameFile+".pdf", '_blank');
        }
    }
    return (
        <div>
            <List>
                {
                    dataTransactions.map(dt => {
                        const response = JSON.parse(dt.response)
                        return <ListItem button >
                                    <ListItemAvatar>
                                        <Avatar>{'$'}</Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        style={{maxWidth: '70%'}}
                                        primary={<span>{`TRANSFERENCIA ${response.type_Transfer.slice(0, -1)}A`}</span>}
                                        secondary={
                                            <div>
                                                <b>{ `Identificación: `}</b>{ `${response.identification} `}
                                                <br/>
                                                <b>{ `Nombre: `}</b>{ `${response.name} `}
                                                <br/>
                                                <b>{ `Monto: `}</b>{ `$ ${response.value} `}
                                                <br/>
                                                {
                                                    !response.error &&
                                                    <Fragment>
                                                        <b>{ `Número de movimiento: `}</b>{ `${response.data.numeroMensajeTransaccion } `}
                                                        <br/>
                                                    </Fragment>
                                                }

                                                {
                                                    response.error ?
                                                    <span><b style={{color:'red'}}>{ `Error de transferencia: `}</b>{ `${response.message}`} </span>:
                                                    <b style={{color:'#6fac22'}}>{ `OK`}</b>
                                                }
                                                <br/>
                                            </div>
                                        }
                                    />
                                    <ListItemSecondaryAction>
                                        {
                                            !response.error &&
                                            (!isMobile ?
                                            <Button
                                            color='secondary'
                                            style={{ width: 'auto' }}
                                            variant="contained"
                                                onClick={
                                                    () => handleDownloadVoucherPayroll(response.data.nombreArchivoComprobante)}
                                                    >
                                                        Descarga Comprobante
                                            </Button>:
                                            <IconButton aria-label="download"
                                                onClick={
                                                () => handleDownloadVoucherPayroll(response.data.nombreArchivoComprobante)}
                                            >
                                                <CloudDownload />
                                            </IconButton>)
                                        }
                                    </ListItemSecondaryAction>
                                </ListItem>
                    })
                }

            </List>
        </div>
    );
};

ShowPayrollVouchers.propTypes = {

};

export default ShowPayrollVouchers;
